/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "client": {
        "nested": {
          "Device": {
            "nested": {
              "Product": {
                "values": {
                  "UNKNOWN": 0,
                  "NONE": 1,
                  "SINGLE_BINARY": 2,
                  "SQUARE": 3,
                  "REGISTER": 4,
                  "KDS": 5,
                  "RETAIL": 6,
                  "RESTAURANT": 7,
                  "DASHBOARD": 8,
                  "APPOINTMENTS": 9,
                  "INVOICES": 10,
                  "READERSDK": 11,
                  "SIGNIN": 12,
                  "TERMINAL_API": 13,
                  "KDS_EXPO": 14,
                  "RESTAURANT_MOBILE": 15,
                  "BALANCE": 16,
                  "FNBKIOSK": 17,
                  "DEVAPP": 18,
                  "TEAM": 19,
                  "KIOSK": 20,
                  "SQUID_KIOSK": 21
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.client?.nested?.Device?.nested?.Product) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE Device @ squareup/client/device.proto at 17:1
 */
export const Device = {};
/**
 * SOURCE Product @ squareup/client/device.proto at 18:3
 */
Device.Product = $root.lookupEnum('squareup.client.Device.Product').values;